module.exports = __webpack_public_path__ + "img/empty_list.eecab64f.png";